<template>
  <v-layout-item
    v-if="announcementFlag.enabled"
    position="top"
    order="-1"
    :size="height"
    model-value
  >
    <v-banner
      ref="banner"
      data-test="announcement-banner"
      bg-color="bg-orange-lighten-5"
      class="content-center"
      :text="text"
    >
      <template #prepend>
        <v-icon icon="mdi-information" color="orange" />
      </template>
    </v-banner>
  </v-layout-item>
</template>

<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import { computed, useTemplateRef } from 'vue'

import { useFlagStore } from '@/stores/flag'

const banner = useTemplateRef('banner')
const { height } = useElementSize(banner, undefined, { box: 'border-box' })

const flagStore = useFlagStore()
const announcementFlag = computed(() => flagStore.getFlag('permanent-announcement-banner'))
const text = computed<string>(() => {
  return typeof announcementFlag.value.value === 'string' ? announcementFlag.value.value : ''
})
</script>
